import { render, staticRenderFns } from "./TabelaPrecoList.vue?vue&type=template&id=08ccac18&scoped=true&"
import script from "./TabelaPrecoList.vue?vue&type=script&lang=js&"
export * from "./TabelaPrecoList.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPrecoList.vue?vue&type=style&index=0&id=08ccac18&prod&lang=scss&scoped=true&"
import style1 from "./TabelaPrecoList.vue?vue&type=style&index=1&id=08ccac18&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ccac18",
  null
  
)

export default component.exports